export default __webpack_public_path__ + "static/media/myTeamPayroll.0fc86a2b.png";